import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Select } from '@ngxs/store';
import { CertificationProvidersState } from 'app/library/certification-provider/models/certification-providers.state';
import { TeamCertificationParentNameEnum } from 'app/library/team/enums/team-certification-dialog-type.enum';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { MaxBrainConfirmDialogComponent } from 'app/projects/shared/src/lib/components/dialogs/confirm/confirm.component';
import { Observable } from 'rxjs';
import { CertificationFlatNode } from '../../providers-all-list/providers-all-list.component';

@Component({
    selector: 'app-replace-certificate-dialog',
    templateUrl: './replace-certificate-dialog.component.html',
    styleUrls: ['./replace-certificate-dialog.component.scss'],
})
export class ReplaceCertificateDialogComponent extends UnsubscribeOnDestroy implements OnInit {
    @Input()
    certificateToBeReplaced: CertificationFlatNode;

    @Input()
    buttonText = 'GENERAL.BUTTON.REPLACE';

    @Input()
    userId: string;

    @Select(CertificationProvidersState.getTotalCount)
    certificationProvidersTotalCount$: Observable<number>;

    displayedColumns: string[] = ['provider', 'certificationName', 'status', 'issueDate', 'expirationDate', 'buttons'];

    isSaveButtonLoading: boolean = false;
    ParentType = TeamCertificationParentNameEnum;
    selectedCertificate: CertificationFlatNode;

    constructor(public dialogRef: MatDialogRef<ReplaceCertificateDialogComponent>, private _matDialog: MatDialog) {
        super();
    }

    async ngOnInit(): Promise<void> {}

    async saveSelected(): Promise<void> {
        if (this.selectedCertificate.expirationDate < this.certificateToBeReplaced.expirationDate) {
            let confirmDialog = this._matDialog.open(MaxBrainConfirmDialogComponent, {
                width: '540px',
                disableClose: false,
            });

            confirmDialog.componentInstance.confirmTitle = 'PAGE.CERTIFICATE.LABEL.EXISTING_CERTIFICATE_FOUND';
            confirmDialog.componentInstance.confirmMessage = 'PAGE.CERTIFICATE.MESSAGE.REPLACE';
            confirmDialog.componentInstance.actionButtonText = 'PAGE.CERTIFICATE.BUTTON.REPLACE_CONFIRM';

            confirmDialog.afterClosed().subscribe(async (result) => {
                if (result) {
                    this.dialogRef.close({ newSelectedCertificate: this.selectedCertificate });
                }

                confirmDialog = null;
            });
        } else {
            this.dialogRef.close({ newSelectedCertificate: this.selectedCertificate });
        }
    }

    onSelectCertificate(certificate: CertificationFlatNode): void {
        this.selectedCertificate = certificate;
    }
}
